import styled from 'styled-components';

export default styled.img`
  width: 48px;
  height: 48px;
  border: none;
`;
